// page top js
{
  "use strict";

  function getScrolled() {
      return (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
  }

  document.addEventListener('DOMContentLoaded', function() {
      const topButton = document.getElementById('page-top');
      if (!topButton) return;

      window.addEventListener('scroll', function() {
          (getScrolled() > 100) 
              ? topButton.classList.add('fade-in') 
              : topButton.classList.remove('fade-in');
      });

      topButton.addEventListener('click', function() {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  });
}


// wishlist floating icon js
{
  "use strict";

    document.addEventListener('DOMContentLoaded', function() {
        let wishlistFloating = document.querySelector('wishlist-link-floating');

        // スクロール位置を取得する関数
        function getScrolled() {
            return (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
        }

        // フェードイン/アウトを制御する関数
        function toggleVisibility(element, scrolled) {
            if (!element) return;

            if (scrolled > 100) {
                element.style.transition = 'opacity 0.3s ease'; // アニメーション
                element.style.opacity = '1'; // 表示
            } else {
                element.style.transition = 'opacity 0.3s ease'; // アニメーション
                element.style.opacity = '0'; // 非表示
            }
        }

        // スクロール時の処理
        window.addEventListener('scroll', function() {
            const scrolled = getScrolled();
            toggleVisibility(wishlistFloating, scrolled);
        });

        // wishlist-link-floatingが非同期で生成される場合の対応
        const observer = new MutationObserver(function() {
            wishlistFloating = document.querySelector('wishlist-link-floating');
            if (wishlistFloating) {
                // 初期状態を非表示に設定
                wishlistFloating.style.opacity = '0';

                // z-indexを設定
                wishlistFloating.style.zIndex = '4';

                observer.disconnect(); // 要素が見つかったら監視を終了
            }
        });

        observer.observe(document.body, { childList: true, subtree: true }); // DOMツリー全体を監視
    });
}